export default __webpack_public_path__ + "static/media/analytics-mobile.a61b60e9.webp";